module.exports = __webpack_public_path__ + "img/logo.2bb42e60.png";